import * as React from 'react'
import { SVGProps } from 'react'
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#4285F4"
      d="M22.988 12.225c0-.984-.078-1.701-.248-2.445H11.73v4.438h6.462c-.13 1.102-.834 2.764-2.397 3.88l-.022.148 3.481 2.75.241.025c2.216-2.086 3.493-5.156 3.493-8.796Z"
    />
    <path
      fill="#34A853"
      d="M11.729 23.918c3.167 0 5.825-1.063 7.767-2.897l-3.701-2.923c-.99.704-2.32 1.196-4.066 1.196-3.101 0-5.734-2.087-6.672-4.97l-.137.012-3.62 2.857-.048.134c1.929 3.906 5.89 6.59 10.477 6.59Z"
    />
    <path
      fill="#FBBC05"
      d="M5.057 14.324a7.493 7.493 0 0 1-.39-2.365c0-.824.143-1.621.377-2.365l-.006-.159-3.666-2.903-.12.059a12.162 12.162 0 0 0-1.25 5.368c0 1.927.455 3.747 1.25 5.368l3.805-3.003Z"
    />
    <path
      fill="#EB4335"
      d="M11.73 4.624c2.201 0 3.687.97 4.534 1.78l3.31-3.295C17.54 1.183 14.896 0 11.729 0 7.142 0 3.181 2.684 1.252 6.59l3.792 3.004c.952-2.884 3.584-4.97 6.685-4.97Z"
    />
  </svg>
)
export default SvgComponent
